import React, { useState } from 'react';
import SectionHeader from '../components/SectionHeader';
import Reveal from '../components/Reveal';
import { tickets, timings } from '../mock';
import { Check, AlertTriangle, Phone } from 'lucide-react';

export default function Tickets() {
  const [tab, setTab] = useState('indian');
  const rows = tickets[tab];

  return (
    <div>
      <div className="relative h-[46vh] min-h-[340px] bg-cover bg-center" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1624951714070-74a95c1f6959?crop=entropy&cs=srgb&fm=jpg&q=85)` }}>
        <div className="absolute inset-0 bg-[#1a1108]/70" />
        <div className="container-x relative z-10 h-full flex flex-col justify-center">
          <span className="eyebrow text-[#f0b040]">Book Now</span>
          <h1 className="font-display text-5xl md:text-6xl text-[#fff8ec] font-bold">Tickets & Timings</h1>
        </div>
      </div>

      <section className="section">
        <div className="container-x">
          <Reveal>
            <SectionHeader eyebrow="Ticket Tariff" title="Choose Your Experience" subtitle="Transparent, all-inclusive pricing. Below 6 years are free." />
          </Reveal>

          <div className="flex gap-2 mb-6">
            {['indian', 'foreign'].map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`px-5 py-2 rounded-full font-semibold text-sm capitalize transition-colors ${tab === t ? 'bg-[#2b1d0e] text-[#fff8ec]' : 'bg-[#fbf3e4] text-[#3d2a12] hover:bg-[#f0e0b8]'}`}
              >
                {t === 'indian' ? 'Indian Visitors' : 'Foreign Visitors'}
              </button>
            ))}
          </div>

          <Reveal>
            <div className="mb-6 p-4 rounded-lg border-l-4 border-[#c04220] bg-[#fdecea] flex items-start gap-3">
              <AlertTriangle size={20} className="text-[#c04220] mt-0.5 flex-shrink-0" />
              <div>
                <div className="font-semibold text-[#8a1e10] text-sm">Service Notice</div>
                <p className="text-sm text-[#5c1c10] mt-1 leading-relaxed">
                  Please note that <strong>A.C. Buses</strong>, <strong>4D Theatre</strong> and the <strong>Interpretation Centre</strong> are currently <strong>not operational</strong>. Only Non-A.C. safari drives are running at present. Prices shown for these services are indicative for future reference.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal>
            <div className="overflow-x-auto">
              <table className="tariff-table">
                <thead>
                  <tr>
                    <th>Age Group</th>
                    <th>Non A.C.</th>
                    <th>A.C.</th>
                    <th>4D Theatre</th>
                    <th>Combo (Non A.C.)</th>
                    <th>Combo (A.C.)</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.age}>
                      <td className="font-medium">{r.age}</td>
                      <td>{typeof r.nonAc === 'number' ? `₹${r.nonAc}` : r.nonAc}</td>
                      <td>{typeof r.ac === 'number' ? `₹${r.ac}` : r.ac}</td>
                      <td>{typeof r.theatre === 'number' ? `₹${r.theatre}` : r.theatre}</td>
                      <td>{typeof r.nonAcCombo === 'number' ? `₹${r.nonAcCombo}` : r.nonAcCombo}</td>
                      <td>{typeof r.acCombo === 'number' ? `₹${r.acCombo}` : r.acCombo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Reveal>

          <div className="mt-10 grid md:grid-cols-2 gap-6">
            <div className="bg-[#fbf3e4] p-6 rounded-lg border border-[#e6d3b0]">
              <h3 className="font-display text-2xl text-[#2b1d0e] mb-4">Visiting Hours</h3>
              {timings.map((t) => (
                <div key={t.period} className="flex justify-between py-2 border-b border-[#e6d3b0] last:border-0">
                  <span className="text-[#3d2a12]">{t.period}</span>
                  <span className="text-[#b8791c] font-semibold">{t.hours}</span>
                </div>
              ))}
            </div>
            <div className="bg-[#2b1d0e] p-6 rounded-lg text-[#f7e6c2]">
              <h3 className="font-display text-2xl text-[#fff8ec] mb-4">What’s Included</h3>
              <ul className="space-y-3 text-sm">
                {['Guided safari drive', 'Lion / Leopard / Deer / Bear zones', 'Interpretation Centre', '4D theatre (with combo)', 'Water bottle & light refreshment (combo)'].map((it) => (
                  <li key={it} className="flex items-start gap-3">
                    <Check size={18} className="text-[#f0b040] mt-0.5 flex-shrink-0" />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <Reveal>
            <div className="mt-10 p-6 rounded-lg bg-gradient-to-r from-[#2b1d0e] to-[#4a3418] text-[#f7e6c2] flex flex-col md:flex-row items-start md:items-center gap-5 shadow-lg">
              <div className="w-14 h-14 rounded-full bg-[#b8791c] flex items-center justify-center flex-shrink-0">
                <Phone size={26} className="text-[#fff8ec]" />
              </div>
              <div className="flex-1">
                <h4 className="font-display text-xl text-[#fff8ec] mb-1">Bulk Bookings & Group Tours</h4>
                <p className="text-sm text-[#f7e6c2] leading-relaxed">
                  For bulk bookings, group tours, and customized safari packages with meals and transportation, please call us at:
                </p>
              </div>
              <a href="tel:+918923493988" className="btn-primary whitespace-nowrap text-base">
                <Phone size={16} /> +91-8923493988
              </a>
            </div>
          </Reveal>

          <div className="text-center mt-12">
            <a href="https://etawahlionsafari.org/book_ticket.aspx" target="_blank" rel="noopener noreferrer" className="btn-primary">Reserve Your Slot</a>
            <p className="text-xs text-[#8b6520] mt-3">Tickets can be purchased directly at the booking counter. If you prefer to book in advance, you may also proceed with online booking.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
